import React from 'react';
import { SocialNetwork } from '@actus/types';
import { SquareSvgProps } from '@icons/icon.types';
import { useTranslation } from '@locales/useTranslation.hook';

function YoutubeLogoIcon({ title, fillColor = '#2D3049', size = 24, ...props }: SquareSvgProps) {
  const { t } = useTranslation(['common']);
  return (
    <svg
      height={size + 4}
      style={{ display: 'flex' }}
      viewBox="0 0 44 44"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{title || t('common.share', { socialNetworkName: SocialNetwork.Youtube })}</title>
      <path
        d="M41.6 13.474s-.39-2.942-1.59-4.237C38.49 7.54 36.786 7.53 36.004 7.434 30.405 7 22.01 7 22.01 7h-.019s-8.396 0-13.993.434c-.782.096-2.485.106-4.008 1.803C2.791 10.532 2.4 13.474 2.4 13.474S2 16.925 2 20.376v3.235c0 3.454.4 6.903.4 6.903s.39 2.941 1.59 4.233c1.522 1.697 3.52 1.646 4.41 1.824C11.6 36.9 22 37 22 37s8.405-.015 14.003-.445c.782-.099 2.486-.11 4.008-1.806 1.199-1.293 1.589-4.233 1.589-4.233s.4-3.451.4-6.903v-3.235c0-3.453-.4-6.904-.4-6.904"
        fill={fillColor}
      />
      <path d="M18 15v14l11-7z" fill="#FFF" />
    </svg>
  );
}

export { YoutubeLogoIcon };
